import { useContext, useState } from 'react'

import ExitToApp from '@material-ui/icons/ExitToApp'
import { EditContext } from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ComplexDialog from 'Components/UI/Molecules/ComplexDialog'
import ComplexDialogActions from 'Components/UI/Molecules/ComplexDialog/Actions'
import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { ESTADO_CLIENTE, SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import Asiento from './Asiento'
import ClientContent from './Client'
import Comprobantes from './Comprobantes'
import HomeContent from './Home'
import PaymentOrder from './PaymentOrder'
import Recibo from './Recibo'
import Shipment from './Shipment'

const Edit = (props) => {
  const {
    open,
    handleclose,
    data,
    dataBefore,
    openCancel,
    cancel,
    closeCancel,
    render,
    setRender,
    orderInfo,
    permissions,
  } = props
  const createDismissableSnackbar = useCustomSnackbar()

  const BLOQUEADO = ESTADO_CLIENTE.find((e) => e.label === 'BLOQUEADO')?.value
  const INHABILITADO = ESTADO_CLIENTE.find((e) => e.label === 'INHABILITADO')?.value

  const isClientBlockedOrDisabled = (estado) => {
    if (estado === null || estado === undefined) return false
    const value = typeof estado === 'string' ? estado.trim().toUpperCase() : Number(estado)
    return (
      value === Number(BLOQUEADO) ||
      value === Number(INHABILITADO) ||
      value === 'BLOQUEADO' ||
      value === 'INHABILITADO'
    )
  }

  const getClientStatusMessage = (estado) => {
    const value = typeof estado === 'string' ? estado.trim().toUpperCase() : Number(estado)
    if (value === Number(BLOQUEADO) || value === 'BLOQUEADO') return 'El cliente está bloqueado.'
    if (value === Number(INHABILITADO) || value === 'INHABILITADO')
      return 'El cliente está inhabilitado.'
    return 'El cliente no está habilitado.'
  }

  const { state, setOpen, setClose } = SetState()
  const [edit] = useContext(EditContext)
  const [loading, setLoading] = useState(false)

  const origenEncontrado = SUCURSAL_ORIGEN.find(
    (sucursal) => sucursal.label === data.infoMain.origen
  )
  const empresaId = origenEncontrado ? origenEncontrado.id : null
  const [dataInfo, setDataInfo] = useState(data)

  const onDataChange = (newData) => {
    setDataInfo((prevDataInfo) => ({
      ...prevDataInfo,
      ...newData,
    }))
  }

  const handleDelete = async () => {
    setLoading(true)
    const empresa = empresaId
    await interfaces.salesOrders
      .deleteOrder(data.infoMain.id, empresa)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        setRender(!render)
        handleclose()
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal!', {
          variant: 'error',
        })
      })
    setLoading(false)
    setClose()
  }

  const handleSubmit = async () => {
    if (isClientBlockedOrDisabled(dataInfo?.ctaCliente?.estado)) {
      createDismissableSnackbar(getClientStatusMessage(dataInfo?.ctaCliente?.estado), {
        variant: 'error',
      })
      return
    }
    const body = {
      infoMain: { ...dataInfo.infoMain, nombre: dataInfo.infoMain.cliente },
      shipping: { ...dataInfo.shipping, destinatario: dataInfo.shipping.destinatario || {} },
      ctaCliente: dataInfo.ctaCliente,
      clienteFactura: dataInfo.clienteFactura,
    }
    const id = data.infoMain.id

    await interfaces.salesOrders.update(id, empresaId, body).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      setRender(!render)
      handleclose()
    })
  }

  const horizontalTabs = [
    {
      id: 0,
      title: 'Inicio',
      color: 'primary',
    },
    {
      id: 1,
      title: 'Cliente',
      color: 'primary',
    },
    [3, 8, 13, 52].includes(data.infoMain.comprobante)
      ? {
          id: 2,
          title: 'Orden de pago',
          color: 'primary',
        }
      : {
          id: 2,
          title: 'Recibos',
          color: 'primary',
        },
    {
      id: 3,
      title: 'Envío',
      color: 'primary',
    },
    {
      id: 4,
      title: 'Asiento',
      color: 'primary',
      disabled: dataInfo.infoMain.origen === 'DOS' ? true : false,
    },
    {
      id: 5,
      title: 'Comprobantes',
      color: 'primary',
      disabled: dataInfo.infoMain.origen === 'DOS' ? true : false,
    },
    {
      id: 6,
      title: 'Historial',
      color: 'primary',
    },
  ]

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <HomeContent
            data={dataInfo}
            setData={setDataInfo}
            dataBefore={dataBefore}
            openCancel={openCancel}
            cancel={cancel}
            handleclose={closeCancel}
            closeModal={handleclose}
            setRender={setRender}
            render={render}
            orderInfo={orderInfo}
            permissions={permissions}
            onDataChange={onDataChange}
          />
        )
      case 1:
        return (
          <ClientContent
            data={dataInfo}
            setData={setDataInfo}
            dataBefore={dataBefore}
            openCancel={openCancel}
            cancel={cancel}
            handleclose={closeCancel}
            setRender={setRender}
            render={render}
            permissions={permissions}
          />
        )
      case 2:
        const isRecibo = [3, 8, 13, 52].includes(data.infoMain.comprobante)
        const commonProps = {
          data: dataInfo,
          onDataChange,
          edit,
          setRender,
          render,
          dataBefore,
          setData: setDataInfo,
          handleclose,
          closeCancel,
          setOpen,
          setIsLoading: setLoading,
          isLoading: loading,
          permissions,
        }
        return isRecibo ? <PaymentOrder {...commonProps} /> : <Recibo {...commonProps} />
      case 3:
        return (
          <Shipment
            data={dataInfo}
            setData={setDataInfo}
            dataBefore={dataBefore}
            dataOr={data.shipping}
          />
        )
      case 4:
        return (
          <Asiento
            data={dataInfo}
            onDataChange={onDataChange}
            edit={edit}
            dataBefore={dataBefore}
            permissions={permissions}
          />
        )
      case 5:
        return <Comprobantes data={dataInfo} onDataChange={onDataChange} edit={edit} />
      case 6:
        return <ComplexDialogHistory history={dataInfo.history} />
      default:
        break
    }
  }

  return (
    <>
      <ComplexDialog
        open={open}
        onClose={handleclose}
        tabs={horizontalTabs}
        height="900px"
        title={
          <>
            {dataInfo.ctaCliente.razon_social}
            {data.infoMain.corresponde && (
              <>
                {[2, 7, 12, 51].includes(dataInfo.infoMain.comprobante) && (
                  <span
                    style={{
                      color: '#3182a9',
                      fontWeight: 'revert',
                      fontSize: '1rem',
                      backgroundColor: '#d9edf7',
                      borderRadius: '.5rem',
                      padding: '.4rem',
                      marginLeft: '1rem',
                    }}
                  >
                    {`Nota de débito ${dataInfo.infoMain.corresponde}`}
                  </span>
                )}

                {[3, 8, 13, 52].includes(dataInfo.infoMain.comprobante) && (
                  <span
                    style={{
                      color: '#3182a9',
                      fontWeight: 'revert',
                      fontSize: '1rem',
                      backgroundColor: '#d9edf7',
                      borderRadius: '.5rem',
                      padding: '.4rem',
                      marginLeft: '1rem',
                    }}
                  >
                    {`Nota de crédito ${dataInfo.infoMain.corresponde}`}
                  </span>
                )}
              </>
            )}

            {dataInfo.ctaCliente.estado === 'Activo' ? (
              <span
                style={{
                  color: '#2C2E2E',
                  fontWeight: 'inherit',
                  fontSize: '1rem',
                  backgroundColor: '#7BE695',
                  borderRadius: '.5rem',
                  padding: '.4rem',
                  marginLeft: '1rem',
                }}
              >
                {dataInfo.ctaCliente.estado.charAt(0).toUpperCase() +
                  dataInfo.ctaCliente.estado.slice(1).toLowerCase()}
              </span>
            ) : dataInfo.ctaCliente.estado === 'INCOBRABLE' ? (
              <span
                style={{
                  color: '#0C1414',
                  fontWeight: 'inherit',
                  fontSize: '1rem',
                  backgroundColor: '#EA7A77',
                  borderRadius: '.5rem',
                  padding: '.4rem',
                  marginLeft: '1rem',
                }}
              >
                {dataInfo.ctaCliente.estado.charAt(0).toUpperCase() +
                  dataInfo.ctaCliente.estado.slice(1).toLowerCase()}
              </span>
            ) : dataInfo.ctaCliente.estado === 'INHABILITADO' ? (
              <span
                style={{
                  color: '#141414',
                  fontWeight: 'inherit',
                  fontSize: '1rem',
                  backgroundColor: '#A6ADAD',
                  borderRadius: '.5rem',
                  padding: '.4rem',
                  marginLeft: '1rem',
                }}
              >
                {dataInfo.ctaCliente.estado.charAt(0).toUpperCase() +
                  dataInfo.ctaCliente.estado.slice(1).toLowerCase()}
              </span>
            ) : dataInfo.ctaCliente.estado === 'CONTROLAR' ? (
              <span
                style={{
                  color: '#2C2E2E',
                  fontWeight: 'inherit',
                  fontSize: '1rem',
                  backgroundColor: '#FFF891',
                  borderRadius: '.5rem',
                  padding: '.4rem',
                  marginLeft: '1rem',
                }}
              >
                {dataInfo.ctaCliente.estado.charAt(0).toUpperCase() +
                  dataInfo.ctaCliente.estado.slice(1).toLowerCase()}
              </span>
            ) : (
              <span
                style={{
                  color: '#fff',
                  fontWeight: 'inherit',
                  fontSize: '1rem',
                  backgroundColor: '#1F1F1F',
                  borderRadius: '.5rem',
                  padding: '.4rem',
                  marginLeft: '1rem',
                }}
              >
                {dataInfo.ctaCliente.estado.charAt(0).toUpperCase() +
                  dataInfo.ctaCliente.estado.slice(1).toLowerCase()}
              </span>
            )}
          </>
        }
        subtitle={`ID ${dataInfo.infoMain.id} - ${dataInfo.infoMain.origen} - Creado el ${dataInfo.infoMain.fecha_creacion} por ${dataInfo.infoMain.usuario}`}
        children={renderTabs}
        actions={
          <ComplexDialogActions
            onClose={handleclose}
            handleSubmit={() => handleSubmit()}
            canEdit={!permissions.allowEdit}
            data={dataInfo}
            editMode={true}
            leftButton={{
              icon: <ExitToApp fontSize="small" />,
              title: 'Eliminar',
              variant: 'contained',
              disabled: data.comprobantes.length > 0 ? true : false,
              style: {
                background: data.comprobantes.length === 0 ? '#f44336' : '#e0e0e0',
                color: data.comprobantes.length === 0 ? '#FFF' : '#A9A9A9',
              },
              onClick: () => {
                setOpen()
              },
            }}
          />
        }
      />

      {state.suspense && (
        <DialogComponent
          open={state.open}
          handleclose={state.loading ? null : setClose}
          widthLarge={500}
          title="¿Desea eliminar el siguiente pedido?"
          subtitle="¡Esta acción es irreversible!"
          disableChildHeight
          disableBackdropClick
          disableEscapeKeyDown
          maxHeight
          actions={
            <CancelConfirmButtons
              onClickSubmit={() => handleDelete()}
              disabledCancel={state.loading}
              disabledSubmit={state.loading}
              isLoading={loading}
            />
          }
        />
      )}
    </>
  )
}

export default Edit
